import { useTranslation } from 'react-i18next';

function ErrorFallback() {
  // Hooks
  const { t } = useTranslation();

  return <h1>{t('global.error')}</h1>;
}

export default ErrorFallback;
